import {createContext} from 'react'

export const StepsContext = createContext()
export const Selected = createContext()